import React, { useState, useContext, useEffect, useMemo, useRef } from 'react';
import { useParams } from 'react-router-dom';

import APICtx from '#api'
import { TplWSidebar as Tpl } from '#Template'
import Search, { SearchAutoComplete, SearchSelect } from '#Search'
import DataList from '#DataList'

import {
	faMagnifyingGlass,
	faDownload,
	faDisplayChartUpCircleDollar,
	faHandHoldingDollar,
	faEnvelope,
} from '@fortawesome/pro-regular-svg-icons'
import { Status } from './Widgets';
import { rcptStatuses } from './def';

const useTableDef = (zones) => {
	const zonesRef = useRef(zones)
	zonesRef.current = zones

	return useMemo(() => ([
		{ label:"Anagrafica", content:async row => row?.label },
		{ label:"Cod. Fisc.", content:async row => row?.taxCode },
		{ label:"Gestione", cellAlign:'center', content:row => <Status {...row} /> },
		{ label:"Zona", content:row => {
			if(!row?.entity?._id)
				return '-- Anagrafica non a sistema --'

			const currentZones = zonesRef.current
			return (
				row?.entity?.zoneZID &&
					currentZones.find(zone => zone.zid === row.entity.zoneZID)?.label
			) || '-- Zona non impostata --'
		}},
	]), [ zones ])
}

export default function WorkflowsList() {
	const api = useContext(APICtx)
	const { processId } = useParams()
	const [ ids, setIds ] = useState([])
	const [ filterEntity, setFilterEntity ] = useState()
	const [ filterStatus, setFilterStatus ] = useState()
	const [ filterZone, setFilterZone ] = useState()
	const [ zones, setZones ] = useState([])

	useEffect(() => {
		api.call('zone/options').then(result => {
			setZones(Array.isArray(result) ? [...result] : [])
		})
	}, [api])

	const tableDef = useTableDef(zones)

	const fetchAddrbookOptions = async searchString =>
		api.call('addrbook/list-options', {
			type: '003',
			searchString,
		})
	const fetchAddrbookLabel = async _id => {
		const item = await api.call('addrbook/get', { _id })
		return item?.label + ' - ' + item?.taxCode
	}

	const handleSetMail = ({ _id, handleRowRefresh }) => {
		api.call('f24/set/mail', { _id }).then(handleRowRefresh)
	}
	const handleSetHand = ({ _id, handleRowRefresh }) => {
		api.call('f24/set/hand', { _id }).then(handleRowRefresh)
	}
	const handleSetTelematic = ({ _id, handleRowRefresh }) => {
		api.call('f24/set/telematic', { _id }).then(handleRowRefresh)
	}

	const handleRefresh = () =>
		api.call('f24/identities/list', { processId, filterEntity, filterStatus, filterZone }).then(setIds)
	useEffect(() => {
		handleRefresh()
	}, [ processId, filterEntity, filterStatus, filterZone ])

	const getRow = _id => api.call('f24/identities/get', { _id })
	const defBtns = [
		{
			icon: faEnvelope,
			label: 'Invia per mail',
			onClick: handleSetMail,
			show: row => row.entity.zoneZID && !row?._state?.locked && !row?._state?.notify,
		},
		{
			icon: faDisplayChartUpCircleDollar,
			label: 'Imposta telematico',
			onClick: handleSetTelematic,
			show: row => row.entity.zoneZID && !row?._state?.locked && !row?._state?.telematic,
		},
		{
			icon: faHandHoldingDollar,
			label: 'Consegna a mano',
			onClick: handleSetHand,
			show: row => row.entity.zoneZID && !row?._state?.locked && (!!row?._state?.telematic || !!row?._state?.notify),
		},

		{
			icon: faMagnifyingGlass,
			label: 'Anteprima allegato',
			onClick: row => api.storage.download(row.pdfJwt, true),
			show: row => Boolean(row.pdfJwt),
		},
		{
			icon: faDownload,
			label: 'Scarica allegato',
			onClick: row => api.storage.download(row.pdfJwt, false),
			show: row => Boolean(row.pdfJwt),
		},
	]

	return (
		<Tpl title="Lista F24">
			<Search>
				<SearchSelect
					label="Zona"
					name="src-zone"
					onChange={setFilterZone}
					options={zones}
					emptyLabel="-- Tutte --"
				/>
				<SearchSelect
					label="Stato"
					name="src-status"
					onChange={setFilterStatus}
					options={rcptStatuses}
					emptyLabel="-- Tutti --"
				/>
				<SearchAutoComplete
					label="Cliente"
					name="src-addrbook"
					onChange={setFilterEntity}
					fetchOptions={fetchAddrbookOptions}
					fetchLabel={fetchAddrbookLabel}
				/>
			</Search>
			<DataList def={tableDef} rowActions={defBtns} ids={ids} getRow={getRow} pageSize={30} />
		</Tpl>
	)
}